import React from 'react'

export default function Rxdocs() {
  return (
    <div>
      <h1>Rxdocs</h1>
    </div>
  )
}
